import { useSelector } from 'react-redux';
import { Request } from 'src/helpers';

const useRequest = (
  loadingOn = () => {},
  loadingOff = () => {},
  extraConfig = {}
) => {
  const {
    userToken,
    base_url,
    isBizSelected = false,
    loginToken
  } = useSelector(state => state.auth);

  const config = {
    headers: {
      'x-access-tokens': isBizSelected ? userToken : loginToken,
      'Content-Type': 'application/json'
    },
    ...extraConfig
  };

  const loadingDisplay = {
    display: loadingOn,
    hide: loadingOff
  };

  const request = new Request(base_url, config, loadingDisplay);

  return request;
};

export default useRequest;
